<template>
  <div class="border-top py-3 mt-1">
    <div class="d-flex ">
      <div class="">
        <div class="break-white-space mb-2">
          {{ data.content.Text.Text }}
        </div>

        <div
          class="panel-bg-file-img mr-1 mb-1 "
          v-bind:style="{
            backgroundImage: 'url(' + data.content.Image.ImageUrl + ')'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object
    },
    dataLength: {
      required: true,
      type: Number
    },
    channelList: {
      required: true,
      type: Array
    }
  },
  computed: {
    channelType: function() {
      return this.channelList.find(el => {
        return el.id == this.data.channelTypeId;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-bg-file-img {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border: 2px dashed #bebebe;
  border-radius: 6px;
  width: 100px;
  height: 100px;
  cursor: pointer;
}
</style>
